import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newCommission({ state }) {
    Vue.swal
      .fire({
        title: "KINDLY COUNTER CHECK!",
        text: "IF YOU HAVE ENTERED THE RIGHT COMMISSION AMOUNT",
        type: "warning",
        showCancelButton: true
      })
      .then(result => {
        if (result.value) {
          let commissionDetails = {
            grand_total: $(".grand_total").val(),
            commission_date: $(".commission_date").val(),
            trip_id: $(".trip_id").val(),
            truck_id: $(".truck_id").val(),
            commission_items: state.commission_items
          };
          $(".creatingCommission").hide();
          $(".creatingCommissionLoader").show();
          baseurl.post(rt.newCommissions, commissionDetails).then(res => {
            $(".creatingCommission").show();
            $(".creatingCommissionLoader").hide();

            if (res.data.code === 200) {
              suc.commissionCreateSuccess();
              router.push("/managetrips");
            } else if (res.data.code === 402) {
              ers.validateErrors();
            } else if (res.data.code === 403) {
              ers.CommissionsExists();
            } else if (res.data.code === 404) {
              ers.errorCreatingCommission();
            } else if (res.data.code === 405) {
              ers.noPermissionToCreate();
              router.push("/managetrips");
            } else if (res.data.code === 506) {
              ses.sessionComplete();
            }
          });
        }
      });
  },

  loadCommission({ commit }) {
    baseurl.get(rt.loadCommissions).then(res => {
      $(".commissionsLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_COMMISSIONS", res.data.commissions);
      } else if (res.data.code === 404) {
        ers.errorLoadingCommission();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      }
    });
  },

  viewCommission({ commit }, commissionId) {
    commit("STORE_COMMISSION_UPDATE", commissionId);
  },

  
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/commissions/actions.js